import { Component, OnInit } from '@angular/core';
import { JobsService, Job, SalaryType } from 'src/app/services/jobs/jobs.service';
import { ActivatedRoute, Params, Router } from '@angular/router';

@Component({
  selector: 'app-job',
  templateUrl: './job.component.html',
  styleUrls: ['./job.component.scss']
})
export class JobComponent implements OnInit {

  job: Job;
  salary: string;
  constructor(private js: JobsService,private activeRoute: ActivatedRoute, private router: Router ) {
    this.job = new Job();
   }
  ngOnInit(): void {
    this.getJob();
  }
  async getJob() {
    let params = await this.activeRoute.params;
    let jobId = params['_value'].id;
    this.job = await this.js.getJob(Number(jobId));
    if(this.job === undefined){
      this.router.navigateByUrl('jobs');
      return;
    }

    switch(this.job.salary.type){
      case SalaryType.FIXED:
        this.salary = SalaryType.toCurrency(this.job.salary.value);
        break;
      case SalaryType.RANGE:
        this.salary = SalaryType.toCurrency(this.job.salary.from) +' - '+SalaryType.toCurrency(this.job.salary.to);
        break;
      case SalaryType.MARKET:
        this.salary = "Market related";
        break;
      case SalaryType.NEGOTIABLE:
        this.salary = "Salary Negotiable";
        break;
      case SalaryType.HIDE:
      default:
        this.salary = '';
        break;
    }
  }

}
